var storeLocal = {};
if (window.store && store.local) storeLocal = store.local;
var storeAdmin = {};
if (window.store && store.admin) storeAdmin = store.admin;
store = {};
store.local = storeLocal;
store.admin = storeAdmin;
store.action = {};
store.action.cartAdd = 'cart/add';
store.action.cartDelete = 'cart/delete';
store.action.cartAdjust = 'cart/adjust';
store.action.cartClear = 'cart/clear';
store.action.cartBox = 'cart/box';
store.action.cartView = 'cart/view';
store.action.cartMedium = 'cart/medium';
store.action.terms = 'index/terms';
store.action.countrySelection = 'index/countryselection';
store.url = function (action, extra) {
	var extraParam = (extra) ? '/' + extra : '';
	return '/_/' + moya.division + '/store/' + action + extraParam;
};
store.$store = null;
store.$ = function() {
	if (null === store.$store) {
		var r = $('#store');
		if (r.length > 0) {
			store.$store = r;
		}
	}
	return store.$store;
};

store.initProduct = function() {
	store.updateBuyButton();
	store.customize.onInitProduct();
	store.local.onInitProduct();
};
// Called by $(document).ready
store.init = function () {
	//noinspection JSUnusedLocalSymbols
	$('.cartAdd').submit(function (data) {
		var f = $(this);
		var params;
		if (window.FormData) {
			params = new FormData(f.get(0));
		}
		else {
			params = {
				variant :f.find('#variant').val(),
				qty :f.find('#qty').val(),
				price :f.find('#price').val(),
				category :f.find('#category').val()
			};
		}
		store.cart.add(params);
		return false;
	});

	//noinspection JSUnusedLocalSymbols
	$('#storeCartBox').delegate('.cartClear', 'click', function (data) {
		store.cart.clear();
		return false;
	});

	$('body').delegate('.cartView .delete', 'click', function(e){
		e.preventDefault();
		store.cart.remove($(this).attr('id').substr(7));
	}).delegate('.cartView .increase', 'click', function(e){
		e.preventDefault();
		store.cart.increase($(this).attr('id').substr(9));
	}).delegate('.cartView .decrease', 'click', function(e){
		e.preventDefault();
		store.cart.decrease($(this).attr('id').substr(9));
	}).delegate('.cartView .cartClear', 'click', function(e){
		e.preventDefault();
		store.cart.clear();
	});

	$('div.elm_Terms label em').click(store.launchTerms).css('cursor', 'pointer');
	$('a.changeCountry').click(store.changeCountryClick);
	store.local.onInit();
};
